import { FETCH_LICENSING_ACTIONS_PROVIDED } from "./LicensingActionsTypes";

const initialState = {
  licensingActions: false,
};

const licensingActionsReducer = (state = initialState, action) => {
  if (action.type === FETCH_LICENSING_ACTIONS_PROVIDED) {
    return {
      ...state,
      licensingActions: action.payload,
    };
  }
  return state;
};

export default licensingActionsReducer;
